import { createFileRoute } from "@tanstack/react-router";
import { TikTokLandingPage } from "@/components/pages/TikTokLandingPage";

const SITE = "https://kentro.com.br";

const META = {
  en: {
    title: "Kentro Sistemas Inteligentes | AI Customer Service for Online Sellers",
    desc: "Went viral and WhatsApp crashed? Kentro handles it with AI, organizes the CRM and converts audience into sales. Chat + CRM + AI in one platform.",
    ogTitle: "Kentro: Chat + CRM + AI for creators and e-commerce",
    ogDesc: "Handle viral spikes with AI on WhatsApp and Direct. Convert audience into sales with Kentro.",
  },
  es: {
    title: "Kentro Sistemas Inteligentes | Atención con IA para quien vende online",
    desc: "¿Te viralizaste y WhatsApp se colgó? Kentro atiende con IA, organiza el CRM y convierte audiencia en venta. Chat + CRM + IA en una sola plataforma.",
    ogTitle: "Kentro: Chat + CRM + IA para creadores y e-commerce",
    ogDesc: "Maneja picos virales con IA en WhatsApp y Direct. Convierte audiencia en ventas con Kentro.",
  },
} as const;

export const Route = createFileRoute("/$locale/tiktok")({
  head: ({ params }) => {
    const loc: "en" | "es" = params.locale === "es" ? "es" : "en";
    const m = META[loc];
    return {
      meta: [
        { title: m.title },
        { name: "description", content: m.desc },
        { property: "og:title", content: m.ogTitle },
        { property: "og:description", content: m.ogDesc },
        { property: "og:url", content: `${SITE}/${loc}/tiktok` },
        { property: "og:locale", content: loc === "es" ? "es_ES" : "en_US" },
      ],
      links: [
        { rel: "canonical", href: `${SITE}/${loc}/tiktok` },
        { rel: "alternate", hrefLang: "pt-BR", href: `${SITE}/tiktok` },
        { rel: "alternate", hrefLang: "en", href: `${SITE}/en/tiktok` },
        { rel: "alternate", hrefLang: "es", href: `${SITE}/es/tiktok` },
        { rel: "alternate", hrefLang: "x-default", href: `${SITE}/tiktok` },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              { "@type": "ListItem", position: 1, name: loc === "es" ? "Inicio" : "Home", item: `${SITE}/${loc}/` },
              { "@type": "ListItem", position: 2, name: 'TikTok', item: `${SITE}/${loc}/tiktok` },
            ],
          }),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": 'WebPage',
            "@id": `${SITE}/${loc}/tiktok`,
            url: `${SITE}/${loc}/tiktok`,
            name: m.title,
            description: m.desc,
            inLanguage: loc === "es" ? "es" : "en",
            isPartOf: { "@type": "WebSite", "@id": `${SITE}/#website` },
          }),
        },
      ],
    };
  },
  component: TikTokLandingPage,
});
